import { useTranslation } from 'react-i18next';

interface FooterProps {
  /** mtime do .xlsx ja formatado em PT-PT, ou null. */
  lastUpdatedLabel: string | null;
  /** True enquanto o hook esta a carregar. */
  loading: boolean;
}

export function Footer({ lastUpdatedLabel, loading }: FooterProps) {
  const { t } = useTranslation();

  let updatedText: string;
  if (loading) updatedText = t('footer.loading');
  else if (lastUpdatedLabel) updatedText = t('footer.updatedAt', { date: lastUpdatedLabel });
  else updatedText = t('footer.updatedPending');

  return (
    <footer className="aiobi-footer">
      <div className="aiobi-footer__primary">{t('footer.copyright')}</div>
      <div className="aiobi-footer__updated">{updatedText}</div>
    </footer>
  );
}
